import { render } from "./PrintFrameSvg.vue?vue&type=template&id=06c45a38&scoped=true&ts=true"
import script from "./PrintFrameSvg.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrintFrameSvg.vue?vue&type=script&setup=true&lang=ts"

import "./PrintFrameSvg.vue?vue&type=style&index=0&id=06c45a38&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c45a38"],['__file',"resources/js/vue/domain/admin/seg-frame-builder/print-page/PrintFrameSvg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06c45a38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06c45a38', __exports__)) {
    api.reload('06c45a38', __exports__)
  }
  
  module.hot.accept("./PrintFrameSvg.vue?vue&type=template&id=06c45a38&scoped=true&ts=true", () => {
    api.rerender('06c45a38', render)
  })

}


export default __exports__